export default __webpack_public_path__ + "static/media/MuseoSans_700-webfont.92c5bae9.woff2";